import type { JanelaBlocoProps } from "./types-janela-bloco";
import { useJanelaBloco } from "./use-janela-bloco";
import { JanelaBlocoView } from "./view-janela-bloco";

/** Bloco Entrada ou Saída da janela de alocação do papel (HU 2034). */
export function JanelaBloco(props: JanelaBlocoProps) {
  const vm = useJanelaBloco(props);

  return <JanelaBlocoView {...vm} />;
}

export type * from "./types-janela-bloco";
export type { JanelaTipo } from "./janela-bloco.constants";
